import { Deserializable } from '../protocols/deserializable';
import { TransferInSubmissionData } from './transfer-in-submission-data';
import { TransferInTransferRecord } from './transfer-in-transfer-record';

export class TransferInSubmission implements Deserializable {
  public new!: TransferInSubmissionData;
  public transferRecord!: TransferInTransferRecord | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.new) {
      this.new = Deserialize.instanceOf(TransferInSubmissionData, this.new);
    }
    if (this.transferRecord) {
      this.transferRecord = Deserialize.instanceOf(TransferInTransferRecord, this.transferRecord);
    }
  }
}
